import { Component, Input } from '@angular/core';
import { ChangeControlDetailsLabels } from '../../enums/change-control-details-labels';
import { ChangeControlDisplayDetails } from '../../models/change-control-display-details';

@Component({
  selector: 'app-change-control-general-details',
  templateUrl: './change-control-general-details.component.html',
  styleUrls: ['./change-control-general-details.component.scss']
})
export class ChangeControlGeneralDetailsComponent {
 @Input() changeControlDisplayDetails: ChangeControlDisplayDetails = {} as ChangeControlDisplayDetails;
  changeControlDetailsLabels = ChangeControlDetailsLabels;

  calculatePhaseColor = (phase: number): string => {
    let statusColor = '';
    switch (phase) {
      case 0:
        statusColor = 'collaboration';
        break;
      case 1:
        statusColor = 'in_review';
        break;
      case 2:
        statusColor = 'ready_for_approval';
        break;
      case 3:
        statusColor = 'implementation';
        break;
      case 4:
        statusColor = 'verification';
        break;
      case 5:
        statusColor = 'complete';
        break;
        case 6:
          statusColor = 'voided'
    }
    return statusColor;
  };
}
